import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getDataSessionRequest, logout } from '../redux/slices/main-slice';
import { RootState } from '@/core/redux/store';
import { useCore } from '@/core/hooks/useCore';
import { showDialog } from '@/core/services/dialog/dialogService';
import { DIALOG_TYPES } from '@/core/types/enums';
import { useTranslation } from 'react-i18next';
import { useToast } from '@/core/services/toast/toastProvider';

export const AuthTokenPage: React.FC = () => {
  const dispatch = useDispatch();
  const { sessionData, getDataSessionError } = useSelector(
    (state: RootState) => state.auth.main
  );
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { gotoPtEApp } = useCore();
  const [firstLoad, setFirstLoad] = React.useState<boolean>(true);
  const toastShownRef = React.useRef<boolean>(false);
  const { t } = useTranslation('auth');
  const toast = useToast();

  useEffect(() => {
    if (!firstLoad) {
      return;
    }

    if (searchParams.get('token')) {
      // Always reset old session data when a new token is provided
      dispatch(logout());
      // Then fetch new session data with the new token
      const token = searchParams.get('token') || '';
      const clientId = searchParams.get('clientId') || '';
      const userRoleSelected = searchParams.get('userRole') || '';
      dispatch(getDataSessionRequest({ token, clientId, userRoleSelected }));
      setFirstLoad(false);
    } else {
      gotoPtEApp();
    }
    const isSuccessConvertSubscription =
      searchParams.get('isSuccessConvertSubscription') || '';
    if (isSuccessConvertSubscription === 'true' && !toastShownRef.current) {
      toast.showSuccess(t('Success'), t('SubscriptionConvertedSuccessfully'));
      toastShownRef.current = true;
    }
  }, [dispatch, gotoPtEApp, searchParams, navigate, firstLoad, toast, t]);

  useEffect(() => {
    if (sessionData) {
      navigate('/', { replace: true });
    }
  }, [sessionData, navigate]);

  useEffect(() => {
    if (getDataSessionError) {
      console.log('AuthTokenPage - getDataSessionError:', getDataSessionError);
      // Show error dialog and redirect to PTE app when authentication fails
      showDialog({
        type: DIALOG_TYPES.ERROR,
        title: t('AuthenticationFailed'),
        description: t('InvalidTokenMessage'),
        primaryButton: {
          text: t('OK'),
        },
        secondaryButton: {
          isShow: false,
          text: '',
        },
      }).finally(() => {
        gotoPtEApp();
      });
    }
  }, [getDataSessionError, gotoPtEApp, t]);

  return null;
};
